/** Picks the POS backend for the order/history tabs: mock (default) or `/api/v1/pos` (same origin/session as ../index.ts). */
import { useMock } from '../index'
import { HttpPosApi } from './http'
import { MockPosApi } from './mock'
import type { PosApi } from './types'

let current: PosApi | null = null

export function getPosApi(): PosApi {
  if (!current) {
    const base = (import.meta.env.VITE_API_BASE ?? '').trim()
    current = useMock ? new MockPosApi() : new HttpPosApi(base)
  }
  return current
}

/** Tests inject their own backend. */
export function setPosApi(api: PosApi | null): void {
  current = api
}

export { PosApiError } from './http'
export type * from './types'
